module.exports = __webpack_public_path__ + "static/media/pro-manPhoto02.4b2447d3.jpg";